export const getBaseUrl = () => {
  return process.env.VUE_APP_API_URL ?? 'https://angelleague.io'
}
